<template>
  <section
    class="card-references"
    v-if="card.setInformationLinkUrl1 || card.setInformationLinkUrl2 || card.cardInformationLinkUrl1 || card.cardInformationLinkUrl2"
  >
    <h4 class="secondary-font">References</h4>

    <div v-if="card.setInformationLinkUrl1">
      <external-link :href="card.setInformationLinkUrl1">
        <span>{{ card.setInformationLinkDescription1 }}</span>
      </external-link>
    </div>

    <div v-if="card.setInformationLinkUrl2">
      <external-link :href="card.setInformationLinkUrl2">
        <span>{{ card.setInformationLinkDescription2 }}</span>
      </external-link>
    </div>

    <div v-if="card.cardInformationLinkUrl1">
      <external-link :href="card.cardInformationLinkUrl1">
        <span>{{ card.cardInformationLinkDescription1 }}</span>
      </external-link>
    </div>

    <div v-if="card.cardInformationLinkUrl2">
      <external-link :href="card.cardInformationLinkUrl2">
        <span>{{ card.cardInformationLinkDescription2 }}</span>
      </external-link>
    </div>
  </section>
</template>

<script>
import ExternalLink from './ExternalLink';

export default {
  components: {
    ExternalLink,
  },

  props: {
    card: Object,
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.card-references {
  padding-top: $gp;
  border-top: solid 1px var(--theme-border);
  margin-bottom: $gp * 1.5;
}
</style>
